import React from 'react'
import { useTranslation } from 'react-i18next'
import T from 'prop-types'

import DotCell from 'components/atoms/DotCell'

export default function AgendaStateCell({ state }) {
  const { t } = useTranslation()

  return (
    <DotCell
      label={t(`agenda.state.${state}`)}
      color={
        state === 'open'
          ? 'success'
          : state === 'closed'
          ? 'textPrimary'
          : 'warning'
      }
    />
  )
}

AgendaStateCell.propTypes = {
  state: T.string.isRequired,
}
